<mat-icon>warning</mat-icon>
<span><ng-content></ng-content></span>
